import {Directive, effect, ElementRef, inject, input, OnDestroy, untracked} from '@angular/core';
import {PanelService} from '../services/panel/panel.service';
import {PanelLocationEnum} from '../enums/panel-location.enum';

@Directive({
    selector: '[appPanelHost]',
    standalone: true,
})
export class PanelHostDirective implements OnDestroy {
    public readonly appPanelHostLocation = input.required<PanelLocationEnum>();
    private readonly panelService = inject(PanelService);
    private readonly hostElement = inject(ElementRef<HTMLElement>);
    private previousLocation: PanelLocationEnum | undefined;

    public constructor() {
        effect(() => {
            const location = this.appPanelHostLocation();

            // This effect must only react to the location. The PanelService calls read the
            // panelEntries signal internally; without untracked the effect would depend on it
            // and run again whenever a panel is opened - it would then unregister itself and
            // close the panel that was just opened.
            untracked(() => {
                if (this.previousLocation !== undefined) {
                    this.panelService.unregisterHost(this.previousLocation, this.hostElement.nativeElement);
                }
                this.previousLocation = location;
                this.hostElement.nativeElement.dataset.panelHostLocation = location;
                this.panelService.registerHost(location, this.hostElement.nativeElement);
            });
        });
    }

    public ngOnDestroy(): void {
        if (this.previousLocation !== undefined) {
            delete this.hostElement.nativeElement.dataset.panelHostLocation;
            this.panelService.unregisterHost(this.previousLocation, this.hostElement.nativeElement);
        }
    }
}
